import { useHead } from '@unhead/react';
import { useState } from 'react';
import { useTranslation } from 'translations/hooks';

import { SingleCardPageWithFilterCardLayout } from 'business/layout/single-card-page-with-filter-card';
import { TableParamsProvider } from 'business/providers/table-params';
import { DEFAULT_PAGE_SIZE } from 'business/quality-control/constants';
import { SegmentHistoryFilters } from 'business/quality-control/pages/segment-history/components/filters';
import { SegmentHistoryHeader } from 'business/quality-control/pages/segment-history/components/segment-history-header';
import { SegmentTable } from 'business/quality-control/pages/segment-history/components/segment-table';
import {
  SegmentHistoryFiltersProvider,
  defaultFilters,
} from 'business/quality-control/pages/segment-history/providers/filters';
import { useFilterData } from 'technical/filter-data';
import { useMediaType } from 'technical/media/hooks';
import { CustomFilterCard } from 'ui/filter-card';
import { SelectedItemsFooter } from 'ui/filter-footer';

import { MobileSegmentHistoryPage } from './mobile';

export interface SegmentHistoryTableFilterData {
  selectedSegments?: number;
}

export const ORDER_FIELD = 'lastScanDate';
export const ORDER_TYPE = 'descend';

export function SegmentHistoryPage() {
  const { t } = useTranslation();

  const { filterData, setFilterData } =
    useFilterData<SegmentHistoryTableFilterData>();

  const [bulkStatusModalOpen, setbulkStatusModalOpen] = useState(false);

  useHead({
    title: t('user.menu.sections.qualityControl.segmentHistory.title'),
  });

  const { isMobile } = useMediaType();

  if (isMobile) {
    return <MobileSegmentHistoryPage />;
  }

  return (
    <TableParamsProvider
      defaultPageSize={DEFAULT_PAGE_SIZE}
      defaultSortField={ORDER_FIELD}
      defaultSortOrder={ORDER_TYPE}
    >
      <SegmentHistoryFiltersProvider initialFilters={defaultFilters}>
        <SingleCardPageWithFilterCardLayout
          title={t('user.menu.sections.qualityControl.segmentHistory.title')}
          header={
            <SegmentHistoryHeader
              onOpenBulkStatusModal={() => setbulkStatusModalOpen(true)}
            />
          }
          filters={
            <CustomFilterCard
              footer={
                filterData?.selectedSegments ? (
                  <SelectedItemsFooter>
                    {t('qualityControl.segmentHistory.selectedItems', {
                      selectedSegments: filterData?.selectedSegments,
                    })}
                  </SelectedItemsFooter>
                ) : null
              }
            >
              <SegmentHistoryFilters />
            </CustomFilterCard>
          }
        >
          <SegmentTable
            setFilterData={setFilterData}
            bulkStatusModalOpen={bulkStatusModalOpen}
            onCloseBulkStatusModal={() => setbulkStatusModalOpen(false)}
          />
        </SingleCardPageWithFilterCardLayout>
      </SegmentHistoryFiltersProvider>
    </TableParamsProvider>
  );
}
